import AdmsIdentifier from './AdmsIdentifier';

export default class AdmsIdentifierList {
  constructor(initialIdentifiers = []) {
    this.identifiersList = initialIdentifiers; // Directly an array
  }

  // Add a new identifier
  addModel(identifier) {
    if (identifier instanceof AdmsIdentifier) {
      this.identifiersList.push(identifier);
    } else {
      throw new Error("Identifier must be an instance of AdmsIdentifier");
    }
  }

  // Remove an identifier by index
  removeModel(index) {
    if (index >= 0 && index < this.identifiersList.length) {
      this.identifiersList.splice(index, 1);
    }
  }

  // Get all identifiersList (this just returns the array)
  getAllModels() {
    return this.identifiersList;
  }

  // Convert to JSON-like object (optional)
  toJSON() {
    return this.identifiersList.map(identifier => identifier.toJSON());
  }
}
